import { TranslationsContext, translation } from '../../../Translations';
import FocusTrap from 'focus-trap-react';
import * as React from 'react';
import { handleEscKeyDown } from '../../../Accessibility/KeyboardEvents';
import MobileCloseIcon from '../../Cutesies/MobileCloseIcon';
import MobileOpenIcon from '../../Cutesies/MobileOpenIcon';
import PositionContext from '../../PositionContext';
import Menu from './Menu';
import NavUser from './NavUser';
import PlatformLogo from './PlatformLogo';
import clsx from 'clsx';
import WaffleSwitcher from './WaffleSwitcher';
import { v4 as uuid } from 'uuid';
import { observer } from 'mobx-react';

interface Props {}
interface State {
  navOpen: boolean;
}
class MainNav extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      navOpen: false,
    };
  }

  id: string = uuid();

  openNav = () => {
    this.setState({ navOpen: true });
  };

  closeNav = () => {
    this.setState({ navOpen: false });
  };
  render() {
    const { navOpen } = this.state;
    return (
      <PositionContext.Provider value={{ kind: 'nav' }}>
        <TranslationsContext.Consumer>
          {(ts) => (
            <>
              <div className="bg-white w-full top-0 z-50">
                <nav className="z-50 relative flex justify-between bg-white px-2.5 py-2.5 lg:hidden">
                  <button
                    className={clsx(
                      'w-[2.635rem] rounded-sm bg-teal-600 py-2.5 px-2',
                      'block h-10 border-none lg:hidden',
                    )}
                    data-test-mobile-open-button={true}
                    data-intercom-target="mobile-navigation-menu"
                    onClick={this.openNav}
                    title={translation('Menu')(ts)}
                    aria-label={translation('Toggle Menu')(ts)}
                    role="button"
                  >
                    <MobileOpenIcon />
                  </button>
                  <span className="block lg:hidden">
                    <NavUser />
                  </span>
                </nav>
                <FocusTrap
                  active={navOpen}
                  focusTrapOptions={{
                    escapeDeactivates: false,
                    allowOutsideClick: true,
                    fallbackFocus: `#${this.id}`,
                  }}
                >
                  <div className="max-w-clientPortalMaxWidth w-full mx-auto">
                    <div id={this.id} tabIndex={-1}>
                      <nav
                        className={clsx(
                          'fixed top-0 bottom-0 -left-full m-0 block lg:w-full',
                          'z-50 shadow-[0_0_20px_rgba(0,0,0,0)] transition-all duration-500',
                          'bg-white ease-in-out lg:flex lg:h-24 lg:justify-between lg:py-5 lg:px-12',
                          'lg:relative lg:items-center',
                          `${navOpen ? 'left-[0%] overflow-y-scroll' : 'lg:left-[0%]'}`,
                        )}
                        onKeyDown={handleEscKeyDown(this.closeNav)}
                        role="navigation"
                      >
                        <div className="flex relative w-8 mr-3">
                          <WaffleSwitcher />
                        </div>
                        <PlatformLogo />
                        <button
                          className={clsx(
                            'absolute top-2.5 right-2.5 w-[2.635rem] bg-teal-600',
                            'block h-10 rounded-sm border-none py-2.5 px-2 lg:hidden',
                          )}
                          data-test-mobile-close-button={true}
                          data-intercom-target="close-mobile-navigation-menu"
                          onClick={this.closeNav}
                          title={translation('Close')(ts)}
                          aria-label={translation('Close Menu')(ts)}
                        >
                          <MobileCloseIcon />
                        </button>
                        <Menu />
                        <span className="hidden lg:flex">
                          <NavUser />
                        </span>
                      </nav>
                    </div>
                  </div>
                </FocusTrap>
              </div>
            </>
          )}
        </TranslationsContext.Consumer>
      </PositionContext.Provider>
    );
  }
}
export default observer(MainNav);
